module.exports = __webpack_public_path__ + "img/678-690deb.png";